import { lazy } from 'react';
import Home from './pages/Home';
import __Layout from './Layout.jsx';

// Eager: Home (main page / LCP) and Layout (wraps every page)
// Lazy: all other pages load on-demand to reduce initial JS payload
const AccountSettings = lazy(() => import('./pages/AccountSettings'));
const ApplicationDetails = lazy(() => import('./pages/ApplicationDetails'));
const Assessments = lazy(() => import('./pages/Assessments'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogAdmin = lazy(() => import('./pages/BlogAdmin'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const CandidateInbox = lazy(() => import('./pages/CandidateInbox'));
const CandidateOfferLetter = lazy(() => import('./pages/CandidateOfferLetter'));
const CandidateOnboarding = lazy(() => import('./pages/CandidateOnboarding'));
const CandidateRelationships = lazy(() => import('./pages/CandidateRelationships'));
const Careers = lazy(() => import('./pages/Careers'));
const ContactSupport = lazy(() => import('./pages/ContactSupport'));
const EmployerDirectory = lazy(() => import('./pages/EmployerDirectory'));
const FacilityDashboard = lazy(() => import('./pages/FacilityDashboard'));
const FacilityDocuments = lazy(() => import('./pages/FacilityDocuments'));
const FacilityProfile = lazy(() => import('./pages/FacilityProfile'));
const FacilitySetup = lazy(() => import('./pages/FacilitySetup'));
const ForEmployers = lazy(() => import('./pages/ForEmployers'));
const Forum = lazy(() => import('./pages/Forum'));
const ForumPost = lazy(() => import('./pages/ForumPost'));
const JobDetails = lazy(() => import('./pages/JobDetails'));
const JobsByLocation = lazy(() => import('./pages/JobsByLocation'));
const LocalJobs = lazy(() => import('./pages/LocalJobs'));
const ManageAlerts = lazy(() => import('./pages/ManageAlerts'));
const Messages = lazy(() => import('./pages/Messages'));
const Network = lazy(() => import('./pages/Network'));
const Newsletter = lazy(() => import('./pages/Newsletter'));
const NursingJobs = lazy(() => import('./pages/NursingJobs'));
const Onboarding = lazy(() => import('./pages/Onboarding'));
const Partnerships = lazy(() => import('./pages/Partnerships'));
const PostJob = lazy(() => import('./pages/PostJob'));
const Referrals = lazy(() => import('./pages/Referrals'));
const ResumeBuilder = lazy(() => import('./pages/ResumeBuilder'));
const SalaryGuide = lazy(() => import('./pages/SalaryGuide'));
const SkillsProficiency = lazy(() => import('./pages/SkillsProficiency'));
const StaffingAgencyDashboard = lazy(() => import('./pages/StaffingAgencyDashboard'));
const StaffingAgencyProfile = lazy(() => import('./pages/StaffingAgencyProfile'));
const StaffingAgencySetup = lazy(() => import('./pages/StaffingAgencySetup'));
const Subscription = lazy(() => import('./pages/Subscription'));
const TalentPool = lazy(() => import('./pages/TalentPool'));
const TeamManagement = lazy(() => import('./pages/TeamManagement'));
const WorkerDashboard = lazy(() => import('./pages/WorkerDashboard'));
const WorkerProfile = lazy(() => import('./pages/WorkerProfile'));
const IndustryGuides = lazy(() => import('./pages/IndustryGuides'));
const GuideDetail = lazy(() => import('./pages/GuideDetail'));
const HealthcareStats = lazy(() => import('./pages/HealthcareStats'));

export const PAGES = {
    "Home": Home,
    "AccountSettings": AccountSettings,
    "ApplicationDetails": ApplicationDetails,
    "Assessments": Assessments,
    "Blog": Blog,
    "BlogAdmin": BlogAdmin,
    "BlogPost": BlogPost,
    "CandidateInbox": CandidateInbox,
    "CandidateOfferLetter": CandidateOfferLetter,
    "CandidateOnboarding": CandidateOnboarding,
    "CandidateRelationships": CandidateRelationships,
    "Careers": Careers,
    "ContactSupport": ContactSupport,
    "EmployerDirectory": EmployerDirectory,
    "FacilityDashboard": FacilityDashboard,
    "FacilityDocuments": FacilityDocuments,
    "FacilityProfile": FacilityProfile,
    "FacilitySetup": FacilitySetup,
    "ForEmployers": ForEmployers,
    "Forum": Forum,
    "ForumPost": ForumPost,
    "JobDetails": JobDetails,
    "JobsByLocation": JobsByLocation,
    "LocalJobs": LocalJobs,
    "ManageAlerts": ManageAlerts,
    "Messages": Messages,
    "Network": Network,
    "Newsletter": Newsletter,
    "NursingJobs": NursingJobs,
    "Onboarding": Onboarding,
    "Partnerships": Partnerships,
    "PostJob": PostJob,
    "Referrals": Referrals,
    "ResumeBuilder": ResumeBuilder,
    "SalaryGuide": SalaryGuide,
    "SkillsProficiency": SkillsProficiency,
    "StaffingAgencyDashboard": StaffingAgencyDashboard,
    "StaffingAgencyProfile": StaffingAgencyProfile,
    "StaffingAgencySetup": StaffingAgencySetup,
    "Subscription": Subscription,
    "TalentPool": TalentPool,
    "TeamManagement": TeamManagement,
    "WorkerDashboard": WorkerDashboard,
    "WorkerProfile": WorkerProfile,
    "IndustryGuides": IndustryGuides,
    "GuideDetail": GuideDetail,
    "HealthcareStats": HealthcareStats,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};